<template>
  <section class="support-section relative py-20 md:py-32 bg-gradient-to-b from-[#1E2652] to-[#1E2652]/95">
    <!-- Background Elements -->
    <div class="absolute inset-0">
      <div class="absolute inset-0 bg-grid opacity-5"></div>
    </div>

    <div class="container relative z-10 mx-auto px-4 md:px-6 max-w-5xl">
      <!-- Section Header -->
      <div class="text-center mb-12">
        <h1 ref="titleRef" class="text-3xl md:text-4xl font-bold text-white mb-4">
          Support
        </h1>
        <p ref="subtitleRef" class="text-lg text-gray-400">
          Notre équipe est là pour vous aider
        </p>
      </div>

      <!-- Support Content -->
      <div class="bg-white/5 backdrop-blur-sm rounded-xl p-6 md:p-8 space-y-8">
        <section class="support-content">
          <h2 class="text-xl md:text-2xl font-semibold text-[#B7E000] mb-4">
            Contactez-nous
          </h2>
          <p class="text-gray-300 mb-6">
            Notre équipe de support est disponible pour répondre à toutes vos questions et vous accompagner.
          </p>
          
          <div class="space-y-6">
            <div class="flex items-center space-x-4">
              <Mail class="w-6 h-6 text-[#B7E000]" />
              <div>
                <h3 class="font-semibold text-[#B7E000]">Email de support</h3>
                <a href="mailto:support@padelgo.ma" class="text-gray-300 hover:text-[#B7E000] transition-colors">
                  support@padelgo.ma
                </a>
              </div>
            </div>
            <div class="flex items-center space-x-4">
              <svg class="w-6 h-6 text-[#B7E000]" fill="currentColor" viewBox="0 0 24 24">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.488"/>
              </svg>
              <div>
                <h3 class="font-semibold text-[#B7E000]">WhatsApp</h3>
                <a href="https://wa.me/33766151241" class="text-gray-300 hover:text-[#B7E000] transition-colors">
                  +33 (0) 7 66 15 12 41
                </a>
              </div>
            </div>
            <div class="flex items-center space-x-4">
              <Clock class="w-6 h-6 text-[#B7E000]" />
              <div>
                <h3 class="font-semibold text-[#B7E000]">Heures de support</h3>
                <p class="text-gray-300">Lundi - Vendredi : 9h - 18h</p>
              </div>
            </div>
          </div>
        </section>

        <!-- <section class="faq-content">
          <h2 class="text-xl md:text-2xl font-semibold text-[#B7E000] mb-4">
            Questions Fréquentes
          </h2>
          <div class="space-y-4">
            <div class="faq-item">
              <h3 class="font-semibold text-[#B7E000] mb-2">Comment réserver un terrain ?</h3>
              <p class="text-gray-300">
                Connectez-vous à votre compte PadelGo, sélectionnez un club partenaire, choisissez une date et un créneau horaire disponible, puis confirmez votre réservation.
              </p>
            </div>
            <div class="faq-item">
              <h3 class="font-semibold text-[#B7E000] mb-2">Comment trouver des partenaires de jeu ?</h3>
              <p class="text-gray-300">
                Utilisez notre fonction de recherche de partenaires en spécifiant votre niveau et vos disponibilités. Vous pouvez également rejoindre des groupes de joueurs existants.
              </p>
            </div>
            <div class="faq-item">
              <h3 class="font-semibold text-[#B7E000] mb-2">Comment annuler une réservation ?</h3>
              <p class="text-gray-300">
                Accédez à vos réservations dans votre profil, sélectionnez la réservation à annuler et suivez les instructions. Notez que les conditions d'annulation peuvent varier selon les clubs.
              </p>
            </div>
          </div>
        </section> -->
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { Mail, Clock } from 'lucide-vue-next'

gsap.registerPlugin(ScrollTrigger)

const titleRef = ref<HTMLElement | null>(null)
const subtitleRef = ref<HTMLElement | null>(null)

onMounted(() => {
  // Subtle fade-in animations
  if (titleRef.value) {
    gsap.from(titleRef.value, {
      y: 20,
      opacity: 0,
      duration: 0.8,
      ease: 'power2.out'
    })
  }

  if (subtitleRef.value) {
    gsap.from(subtitleRef.value, {
      opacity: 0,
      duration: 0.8,
      delay: 0.2,
      ease: 'power2.out'
    })
  }

  const sections = document.querySelectorAll('.support-content, .faq-content')
  sections.forEach((section, index) => {
    gsap.from(section, {
      opacity: 0,
      y: 20,
      duration: 0.8,
      delay: 0.1 * index,
      ease: 'power2.out',
      scrollTrigger: {
        trigger: section,
        start: 'top 90%'
      }
    })
  })
})
</script>

<style scoped>
.support-content, .faq-content {
  @apply transition-all duration-300;
}

.support-content:hover, .faq-content:hover {
  @apply transform translate-x-1;
}

.faq-item {
  @apply p-4 rounded-lg bg-white/5 hover:bg-white/10 transition-colors duration-300;
}
</style>